var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(" "+_vm._s(_vm.$t('reminder.body'))+" "),_c('a',{attrs:{"href":"#result-faq"}},[_vm._v(_vm._s(_vm.$t('reminder.namechecker')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }